import React, { useState } from 'react';
import './LinksMenu.css';
import newFoxesLogo from '../assets/logo.png';

const OFFICIAL_LINKS = [
  { name: 'Twitter', url: 'https://twitter.com/newfoxesworld' },
  { name: 'Instagram', url: 'https://instagram.com/newfoxesworld' },
  { name: 'Discord', url: 'https://discord.newfoxes.com' },
  { name: 'Facebook', url: 'https://www.facebook.com/NewFoxesWorld/' },
  { name: 'NFT Marketplace', url: 'https://shop.newfoxes.com' },
  { name: '$NOX Token', url: 'https://nox.newfoxes.com' },
];

const MORE_LINKS = [
  { name: 'Swap $NOX', url: 'https://okx.newfoxes.com/nox' },
  { name: 'Add Liquidity', url: 'https://nox.newfoxes.com/liquidity' },
  { name: 'FoxPay Bot', url: 'https://top.gg/bot/1212407364502953994' },
];

const LinksMenu = ({ isPlayerVisible, onTogglePlayer }) => {
  const [isMenuOpen, setMenuOpen] = useState(false);

  const toggleMenu = () => setMenuOpen(!isMenuOpen);
  const closeMenu = () => setMenuOpen(false);

  const handleMusicToggle = (e) => {
    e.preventDefault();
    e.stopPropagation();
    onTogglePlayer(!isPlayerVisible);
  };

  return (
    <>
      <div className="links-menu-container">
        <a href="https://www.newfoxes.com" target="_blank" rel="noopener noreferrer" className="header-logo">
            <img src={newFoxesLogo} alt="New Foxes Logo" />
        </a>
        <nav className="desktop-links">
          <button onClick={handleMusicToggle} className="desktop-link-button music-toggle">
            {isPlayerVisible ? 'Hide Player' : 'Show Player'}
          </button>
          {OFFICIAL_LINKS.slice(0, 3).map(link => (
            <a key={link.name} href={link.url} target="_blank" rel="noopener noreferrer">{link.name}</a>
          ))}

          <button onClick={toggleMenu} className="desktop-link-button">More...</button>
        </nav>
        <button className="mobile-menu-toggle" onClick={toggleMenu}>
          ☰
        </button>
      </div>

      <div className={`nav-overlay ${isMenuOpen ? 'open' : ''}`} onClick={closeMenu}>
        <nav className="links-popup" onClick={(e) => e.stopPropagation()}>
          <button className="close-button" onClick={closeMenu}>×</button>
          
          {OFFICIAL_LINKS.map(link => (
            <a key={link.name} href={link.url} target="_blank" rel="noopener noreferrer" onClick={closeMenu}>
              {link.name}
            </a>
          ))}
          <div className="popup-divider"></div>
          {MORE_LINKS.map(link => (
             <a key={link.name} href={link.url} target="_blank" rel="noopener noreferrer" onClick={closeMenu}>
              {link.name}
            </a>
          ))}
          <div className="popup-divider"></div>
          <a href="#" className="music-toggle-mobile" onClick={(e) => { handleMusicToggle(e); closeMenu(); }}>
            {isPlayerVisible ? 'Hide Music Player' : 'Show Music Player'}
          </a>
        </nav>
      </div>
    </>
  );
};

export default LinksMenu;